import { c as _c } from "react/compiler-runtime";
import { getOrgInvestigationsByIdTraceOptions } from '@onefootprint/fetch-dashboard';
import type { AgentExecutionTraceEntry } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import { agentNodeName } from '@/utils/agent-node';
import type { ArtifactPlanTask } from '../components/artifact-sidebar';

// Maps the investigation trace (graph nodes in order, each with the latest execution's completion
// time) to the sidebar's plan. Returns undefined when there are no entries (eg a non-agent investigation).
export const traceToPlan = (entries: AgentExecutionTraceEntry[]): ArtifactPlanTask[] | undefined => entries.length === 0 ? undefined : entries.map(({
  node,
  context
}) => ({
  nodeId: node.id,
  label: agentNodeName(node),
  completedAt: context?.completedAt
}));

// Fetches the agent trace for an investigation and derives the grouped-sidebar plan. `enabled` gates
// the fetch to agent-run investigations — others have no trace and 403/empty otherwise.
const useInvestigationTrace = t0 => {
  const $ = _c(5);
  const {
    investigationId,
    enabled
  } = t0;
  let t1;
  if ($[0] !== investigationId) {
    t1 = getOrgInvestigationsByIdTraceOptions({
      path: {
        id: investigationId
      }
    });
    $[0] = investigationId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = enabled && !!investigationId;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      ...t1,
      enabled: t2,
      select: _temp
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return useQuery(t3);
};
export default useInvestigationTrace;
function _temp(response) {
  return traceToPlan(response.entries);
}